import { put, call, takeEvery } from 'redux-saga/effects';
import scogo_apis from '../scogo_apis';
import { toast, utils, loading, modal } from '../types';

export function* getPreferences(action) {
    let { type, module, org_id, user_id, level, role_id, level_id } = action.payload;
    try {
        const q = { type, module, org_id };
        if (level_id) q.level_id = level_id;
        if (user_id) q.user_id = user_id;
        if (role_id) q.role_id = role_id;
        const response = yield call(scogo_apis.utils.getPreferences, {}, {}, q, {});
        if (response.status === 200) {
            yield put({ type: utils.GET_PREFERENCES_SUCCESS, payload: { module, data: response.data, type, level_id } });
        } else {
            yield put({ type: utils.GET_PREFERENCES_FAILURE, payload: response.data.data.message });
        }
    } catch (err) {
        yield put({ type: utils.GET_PREFERENCES_FAILURE, payload: 'Something went wrong' });
    }
}

export function* copyToClipboard(action) {
    const { data } = action.payload;

    try {
        if (typeof data === 'object') {
            navigator.clipboard.writeText(data);
        } else {
            navigator.clipboard.writeText(data);
        }
        let message = 'Successfully Copied To Clipboard';
        let status = 'success';
        yield put({ type: toast.SEND_TOAST, payload: { status, message } });
    } catch (error) {
        yield put({ type: utils.COPY_TO_CLIPBOARD_FAILURE, payload: { message: error } });
    }
}

export function* downloadFiles(action) {
    const { files } = action.payload;
    try {
        let status = 'success';
        let message = files.length === 1 ? 'File Downloaded Successfully' : 'Files Downloaded Successfully';
        for (let i = 0; i < files.length; i++) {
            let file = files[i];
            const { url, fileName, mimeType } = file;
            let blob = yield call(async () => await fetch(url, {
                method: 'GET',
                mode: 'cors',
                cache: 'no-cache',
                headers: { Origin: window.location.origin },
            }).then((r) => r.blob()), url);
            const a = document.createElement('a');
            a.style.display = 'none';
            document.body.appendChild(a);
            a.href = window.URL.createObjectURL(new Blob([blob], { type: mimeType }));
            a.setAttribute('download', fileName);
            a.click();
            window.URL.revokeObjectURL(a.href);
            document.body.removeChild(a);
        }
        yield put({ type: toast.SEND_TOAST, payload: { status, message } });
    } catch (error) {
        yield put({ type: toast.SEND_TOAST, payload: { status: 'danger', message: 'Something Went Wrong' } });
    }
}

export function* getReportColumns(action) {
    const { report, formName } = action.payload;
    try {
        yield put({ type: loading.FORM_BUTTON_LOADING, payload: { formName, isLoading: true } });
        const response = yield call(scogo_apis.reports.getColumns, {}, { report }, {});
        if (response.status === 200) {
            yield put({ type: utils.GET_REPORT_COLUMNS_SUCCESS, payload: { data: response.data, report } });
        }
    } catch (error) {
        console.log('error:', error);
        yield put({ type: toast.SEND_TOAST, payload: { status: 'danger', message: error.response.data.messages[0] || 'Something went wrong' } });
    }
    yield put({ type: loading.FORM_BUTTON_LOADING, payload: { formName, isLoading: false } });
}

export function* requestReport(action) {
    const { payload, formName } = action.payload;
    try {
        yield put({ type: loading.FORM_BUTTON_LOADING, payload: { formName, isLoading: true } });
        const response = yield call(scogo_apis.reports.request, {}, {}, {}, payload);
        if (response.status === 201) {
            yield put({ type: toast.SEND_TOAST, payload: { status: 'success', message: response.data.message || 'Report requested successfully' } });
            yield put({ type: modal.CLOSE_MODAL });
        }
    } catch (error) {
        console.log('error:', error)
        yield put({ type: toast.SEND_TOAST, payload: { status: 'danger', message: error.response.data.messages[0] || 'Something went wrong' } });
        yield put({ type: loading.FORM_BUTTON_LOADING, payload: { formName, isLoading: false } });
    }
    yield put({ type: loading.FORM_BUTTON_LOADING, payload: { formName, isLoading: false } });
}

export function* sendAlert(action) {
    const { payload, formName } = action.payload;
    try {
        yield put({ type: loading.FORM_BUTTON_LOADING, payload: { formName, isLoading: true } });
        const response = yield call(scogo_apis.alert.sendAlert, {}, {}, {}, payload);
        if (response.status === 201) {
            yield put({ type: toast.SEND_TOAST, payload: { status: 'success', message: response.data.message || 'Alert sent successfully' } });
            yield put({ type: modal.CLOSE_MODAL });
        }
    } catch (error) {
        console.log('error:', error);
        yield put({ type: toast.SEND_TOAST, payload: { status: 'danger', message: error?.response?.data?.messages?.[0] || 'Something went wrong' } });
    }
    finally {
        yield put({ type: loading.FORM_BUTTON_LOADING, payload: { formName, isLoading: false } });
    }
}

export default function* utilsSaga() {
    yield takeEvery(utils.GET_PREFERENCES_REQUEST, getPreferences);
    yield takeEvery(utils.COPY_TO_CLIPBOARD_REQUEST, copyToClipboard);
    yield takeEvery(utils.DOWNLOAD_FILE_REQUEST, downloadFiles);
    yield takeEvery(utils.GET_REPORT_COLUMNS_REQUEST, getReportColumns);
    yield takeEvery(utils.REQUEST_REPORT_REQUEST, requestReport);
    yield takeEvery(utils.SEND_ALERT_REQUEST, sendAlert);
}



